<template>
      	<div class="header-wrapper">
    <div class="header_left">
      <img src="../../../../static/images/newRealTask/zljy-logo.png" alt="" @click="$router.push('/Home')">
      <el-button v-if="flag == 2" @click="myfuntion" class="goback"><i class="el-icon-arrow-left"></i>公司与项目</el-button>
      <p @click="$router.push('/Home')" v-else-if="flag == 1">
        <i class="el-icon-sort"></i>
        {{ prodName ? prodName : deptName }}
      </p>
    </div>
    <div class="header_right">
      <div class="login-user">
        <el-dropdown @command="handleCommand" :show-timeout="0">
          <div class="user-name el-dropdown-link">
              <div class="imgBox">
                <img :src="imgUrl">
              </div>
              <div class="login-name">{{name}}</div>
          </div>
          <el-dropdown-menu slot="dropdown">
            <el-dropdown-item command="d">退出</el-dropdown-item>
          </el-dropdown-menu>
        </el-dropdown>
      </div>
    </div>
  </div>
</template>
<script>
export default {
  data() {
    return {
      flag:1,
      name:'',
        userType: '',
        imgUrl:'../../../static/images/hed0.png',
        professional: sessionStorage.getItem('professional')?sessionStorage.getItem('professional'):2,
        curId: 0,
        prodName: sessionStorage.getItem('prodName'),
        deptName: sessionStorage.getItem('deptName'),
    }
  },
      created() {
      if(this.$route.path.split('/')[1] == 'educa'){
        this.curId = 0
      }else if(this.$route.path.split('/')[1] == 'settings'){
        this.curId = 1
      }else if(this.$route.path.split('/')[1] == 'dataStatistics'){
        this.curId = 2
      }else{
        this.curId = 3
      }
      if(localStorage.getItem('isbinding')&&localStorage.getItem('isbinding')==0){
        this.$router.push({path:'/'})
      }
      this.name = sessionStorage.getItem('loginName');
      this.userType = sessionStorage.getItem('userType');
    },
    methods: {
      init(){
  this.flag = localStorage.getItem("returnParameters")
  console.log(this.flag,"flag");
      },
      myfuntion(){
this.$router.go(-1)
        localStorage.setItem("returnParameters",1)
      },
      handleCommand(command){//退出
        if(command == 'd'){
          this.$logOut()
        }else if(command == 'a'){
          this.$router.push('/educa')
        }else if(command == 'b'){
          this.$router.push('/settings')
        }
        else if(command == 's'){
          this.$router.push('/dataStatistics')
        }
      },
       handleCommand(command){
        if(command == 'd'){
          this.$logOut()
        }else if(command == 'a'){
          this.$router.push('/educa')
        }else if(command == 'b'){
          this.$router.push('/settings')
        }else if(command == 's'){
          this.$router.push('/dataStatistics')
        }
      },
    },
        watch: {
      '$route' (to, from) {
        if(to.path.split('/')[1] == 'educa'){
          this.curId = 0
        }else if(to.path.split('/')[1] == 'settings'){
          this.curId = 1
        }else if(to.path.split('/')[1] == 'dataStatistics'){
          this.curId = 2
        }else{
          this.curId = 3
        }
      }
    },
  }
</script>

<style lang="scss">
    .header-wrapper {
    height:50px;
    background:white;
    display: flex;
    justify-content: space-between;
    .header_left{
      display: flex;
      align-items: center;
      img{
        height: 28px;
        margin-left: 15px;
        margin-right: 15px;
      }
      p{
        font-size:16px;
        font-weight: 600;
        line-height:27px;
        color:#004E96;;
        position: relative;
        margin-left: 15px;
        cursor: pointer;
        &::after{
          content: '';
          position: absolute;
          left: -15px;
          top: 5px;
          width: 1px;
          height: 20px;
          background: #fff;
        }
        i{
          transform: rotate(90deg);
          margin-right: 5px;
          color:#004E96;;
        }
      }
    }
          .goback{
        width: 90px;
        height: 27px;
        border: none;
        border-radius: 4px;
        font-size: 16px;
        font-weight: 600;
        color: #004E96;
        box-sizing: border-box;
        position: relative;
        padding: 0;
        margin-left: 20px;
        i{
          color: #004E96;
          font-weight: 600;
        }
        &::after{
          content: "";
          position: absolute;
          left: 4px;
          top: 0;
          bottom: 0;
          margin: auto;
          width: 16px;
          height: 16px;
          // background: url("/static/images/newCourse/home.png") no-repeat;
          // background-size: 100% 100%;
        }
        &:hover{
          color: #1890FF;
          background: none;
          i{
            color: #1890FF;
          }
          // &::after{
          //   background: url("/static/images/newCourse/homeActive.png") no-repeat;
          //   background-size: 100% 100%;
          // }
        }
        &::before{
          content: "";
          position: absolute;
          left: -15px;
          top: 0;
          bottom: 0;
          margin: auto;
          width: 2px;
          height: 20px;
          background: #004E96;
        }
      }
    .header_right{
      display: flex;
        align-items: center;
      .right_menu{
        display: flex;
        align-items: center;
        margin-right: 24px;
        li{
          position: relative;
          width: 100px;
          text-align: center;
          cursor: pointer;
          span{
            color: #fff;
            font-size:12px;
            font-weight:normal;
            letter-spacing:1px;
          }
          &::after{
            content: '';
            width: 1px;
            height: 12px;
            background: #fff;
            position: absolute;
            right: 0;
            top: 4px;
          }
        }
        .active{
          span{
            // color: darkorange;
            color: #fff;
            font-weight: 600;
            font-size: 14px;
          }
        }
      }
    }
    .login-user {
      position: relative;
      cursor: pointer;
      .login-name {
        margin-left: 6px;
        color: #004E96;;
        line-height: 20px;
      }
      .user-name {
        height: 64px;
        display: flex;
        align-items: center;
        .imgBox {
          width: 30px;
          height: 30px;
          text-align: center;
          line-height: 30px;
          border: 1px solid #333;
          border-radius: 50%;
          img{
            height: 100%;
          }
        }
      }
      .el-dropdown {
        margin-right: 32px;
      }
      &:hover{
        .login-name {
          opacity: 0.8;
        }
      }
    }
  }
</style>



// WEBPACK FOOTER //
// src/views/newRealTask/components/newRealyObjectHeader.vue